var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoyLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0527344,
    y: 0.241211,
    width: 45.0517,
    height: 47.3621,
    rx: 10,
    fill: "#0066FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3852 11.8195C17.9545 10.7809 19.3776 10.7809 19.9468 11.8195L24.5009 20.129C25.0701 21.1677 24.3586 22.466 23.2201 22.466H14.112C12.9735 22.466 12.262 21.1677 12.8312 20.129L17.3852 11.8195Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4097 34.8696C24.8405 35.9083 23.4174 35.9083 22.8482 34.8696L18.2941 26.5602C17.7248 25.5215 18.4364 24.2231 19.5749 24.2231H28.683C29.8214 24.2231 30.533 25.5215 29.9638 26.5602L25.4097 34.8696Z",
    fill: "#99C2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoyLogo2);
export default __webpack_public_path__ + "static/media/coy-logo2.4e985c32d4f773fb7c9479984bee593c.svg";
export { ForwardRef as ReactComponent };